import { ApiResponse } from "../Types";
import { RepairJobFilters, RepairJobFormData } from "../Types/RepairJobTypes";
import { axiosClientv1 } from "./apiClient";

export const getRepairJobs = async (
  filters: RepairJobFilters = {},
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get("/repair-jobs", {
      params: filters,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load repair jobs.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const getRepairJobById = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get("/repair-jobs/view", {
      params: { id },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load repair job.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const createRepairJob = async (
  data: RepairJobFormData,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/repair-jobs/create", data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create repair job.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const updateRepairJob = async (
  data: RepairJobFormData & { id: string },
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/repair-jobs/update", data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update repair job.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const deleteRepairJob = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/repair-jobs/delete", {
      id,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete repair job.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const addPayment = async (data: {
  repair_job_id: string;
  payment_method_id: string;
  amount: number;
  bank_account_id?: string;
  transaction_no?: string;
  cheque_no?: string;
  bank_name?: string;
  cheque_date?: string;
  notes?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/repair-jobs/add-payment", data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to add payment.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const addPart = async (data: {
  repair_job_id: string;
  product_id?: string;
  part_name: string;
  part_code?: string;
  quantity?: number;
  unit_price?: number;
  notes?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/repair-jobs/add-part", data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to add part.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const updateRepairJobStatus = async (data: {
  id: string;
  status: string;
  status_note?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      "/repair-jobs/update-status",
      data,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update status.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const deletePart = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/repair-jobs/delete-part", {
      id,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete part.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
